// extracted by mini-css-extract-plugin
module.exports = {"login_wrapper":"register_login_wrapper__1ahVQ","bkImg":"register_bkImg__1NXs0","wrapper":"register_wrapper__1wUhM","creds":"register_creds__1mvL0","btn":"register_btn__14MlA"};